import Vue from 'vue';
import { trySkewFromHttpHeaders } from '@/utils/clock-skew';

Vue.$http.interceptors.response.use(
  (response) => {
    trySkewFromHttpHeaders();
    return response;
  },
  (error) => {
    if (error.response) {
      trySkewFromHttpHeaders();
    }
    return Promise.reject(error);
  },
);



// WEBPACK FOOTER //
// ./src/store/proxies/interceptors/clock-skew-interceptor.js